import { prefixObjectValues } from '../utils';

const modal = {
  form: 'form',
  employmentNameInput: 'name-input',
  startDatePicker: 'start-date-picker',
  currentToggle: 'current-toggle',
  endDatePicker: 'end-date-picker',
  titleInput: 'title-input',
  departmentInput: 'department-input',
  appointmentSelect: 'appointment-select',
  facilityNameSelect: 'facility-select',
  facilityAddBtn: 'facility-add-btn',
  locationInput: 'location-input',
  privilegesHeldCheckbox: 'privileges-checkbox',
  rehireEligibleToggle: 'employment-rehire-toggle',
  reasonForLeaving: 'reason-textArea',
  cancelBtn: 'cancel-btn',
  submitBtn: 'submit-btn',
};

export default prefixObjectValues(modal, 'account-employment-form');
